import { render, staticRenderFns } from "./HospitalsAndClinic.vue?vue&type=template&id=76218906&"
import script from "./HospitalsAndClinic.vue?vue&type=script&lang=js&"
export * from "./HospitalsAndClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports